import SvgMapper from "../features/common/SvgMapper";

const InterviewReviewMain = ({ onClick }) => {
  return (
    <>
      <div className ="bg-white rounded-lg border border-gray-200" onClick={onClick}>
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Recent Interviews</h2>
        </div>
        <div className="divide-y divide-gray-200">
          <div className="p-6 hover:bg-gray-50 cursor-pointer">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  {SvgMapper.user("w-6 h-6 text-blue-600")}
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Sarah Johnson</h3>
                  <p className="text-sm text-gray-600">
                    Agency Paid Media - Meta and Google
                  </p>
                  <div className="flex items-center space-x-4 mt-1">
                    <span className="text-xs text-gray-500 flex items-center">
                      {SvgMapper.calendar("w-3 h-3 mr-1")}
                    </span>
                    <span className="text-xs text-gray-500 flex items-center">
                      {SvgMapper.clock("w-3 h-3 mr-1")}
                      28:45
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="text-right">
                  <div className="flex items-center space-x-2">
                    {SvgMapper.award("w-4 h-4 text-gray-400")}
                    <span className="font-semibold text-gray-900">78%</span>
                  </div>
                  <span className="text-xs px-2 py-1 rounded-full font-medium text-green-600 bg-green-50">
                    completed
                  </span>
                </div>
                <div className="w-3 h-3 rounded-full bg-green-400"></div>
                {SvgMapper.eye("w-5 h-5 text-gray-400")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InterviewReviewMain;
